module.exports = __webpack_public_path__ + "static/media/covid_adolescent_p1_1.b84f26ee.png";